import { render } from "./SecuritySection.vue?vue&type=template&id=30edc3ab&scoped=true"
const script = {}

import "./SecuritySection.vue?vue&type=style&index=0&id=30edc3ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30edc3ab"]])

export default __exports__